import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  sectionContainer: {
    paddingBottom: '45px',
    backgroundColor: colors.white,
  },
  topContainer: {
    paddingTop: '45px',
  },
  subtitle: {
    marginTop: '12px',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '20px',
  },
});
